import { g as r } from "../internals/global.js";
import { f as e } from "../internals/fails.js";
import { f as a } from "../internals/function-uncurry-this.js";
import { a as s } from "../internals/array-buffer-view-core.js";
import { e as t } from "./es.array.iterator.js";
import { w as n } from "../internals/well-known-symbol.js";
var i = n("iterator"),
  o = r.Uint8Array,
  l = a(t.values),
  u = a(t.keys),
  f = a(t.entries),
  m = s.aTypedArray,
  y = s.exportTypedArrayMethod,
  p = o && o.prototype,
  v = !e(function () {
    p[i].call([1]);
  }),
  c = !!p && p.values && p[i] === p.values && "values" === p.values.name,
  j = function j() {
    return l(m(this));
  };
y("entries", function () {
  return f(m(this));
}, v), y("keys", function () {
  return u(m(this));
}, v), y("values", j, v || !c, {
  name: "values"
}), y(i, j, v || !c, {
  name: "values"
});